import { LoadingScreen } from "chrome/LoadingScreen";

export const AuthCompletedScreen = () => {
  return <LoadingScreen mode="auth" />;
};
